import { lazy } from 'react';
import ReactDOM from 'react-dom/client';

const blocks: { [name: string]: any } = {
  /* DEVELOPMENT_ONLY */
  root: lazy(() => import('@xpack/root')),
  quantityStepperDemo: lazy(() => import('@molecules/quantity-stepper/demo')),
  drawSliderTemplate: lazy(() => import('@templates/draw-slider')),
  /* END_DEVELOPMENT_ONLY */
  cartDetails: lazy(() => import('@organisms/cart-components/cart-details')),
  cartDonation: lazy(() => import('@organisms/cart-components/cart-details/cart-donation')),
  completeProfileForm: lazy(() => import('@organisms/complete-profile-form')),
  cartPayment: lazy(() => import('@organisms/cart-components/payment-methods/cart-payment')),
  purchaseConfirmation: lazy(() => import('@organisms/cart-components/purchase-confirmation')),
  paymentDetails: lazy(() => import('@organisms/my-account-components/payment-details')),
  consentCentre: lazy(() => import('@organisms/consent-centre')),
  myplace: lazy(() => import('@organisms/my-place')),
  accountDetails: lazy(() => import('@organisms/my-account-components/account-details')),
  purchaseHistory: lazy(() => import('@organisms/my-account-components/purchase-history')),
  donationSubscriptionForm: lazy(() => import('@organisms/donation-subscription-form')),
  bullyingQuiz: lazy(() => import('@organisms/bullying-quiz')),
  drawSlider: lazy(() => import('@organisms/draw-slider')),
};

const loadComponent = (scriptSection: HTMLScriptElement) => {
  const blockType = scriptSection.getAttribute('data-rct');
  const data = scriptSection.textContent ? scriptSection.textContent : '{}';

  if (!blockType || !data) {
    return;
  }

  let Component = null;

  try {
    Component = blocks[blockType];
  } catch (error) {
    console.error(`Error loading component for block type: ${blockType}`, error);
  }

  if (Component) {
    scriptSection.textContent = null;
    const section = document.createElement(scriptSection.getAttribute('data-tag') ?? 'section');

    section.className = scriptSection.getAttribute('data-class') ?? '';
    scriptSection.replaceWith(section);

    const props = JSON.parse(data);

    ReactDOM.createRoot(section).render(<Component {...props} />);
  } else {
    return <></>;
  }
};

const loadComponents = () => {
  // rct stands for 'react component type'
  const scriptSections = document.querySelectorAll('script[data-rct]');

  [].forEach.call(scriptSections, loadComponent);
};

loadComponents();
window.addEventListener('load', () => loadComponents());
